import {AbstractControl} from '@angular/forms';

export function floatValidator(control: AbstractControl): { [key: string]: any } | null {
  const value = control.value;

  if (value === null || value === undefined || value === '') {
    return null;
  }

  const isValidFloat = /^[+-]?\d+(\.\d+)?$/.test(value);

  return isValidFloat ? null : {float: true};
}
